import { render } from "./FrmDumpMerchandiseLogisticUnitHome.vue?vue&type=template&id=4c18579d"
import script from "./FrmDumpMerchandiseLogisticUnitHome.vue?vue&type=script&lang=js"
export * from "./FrmDumpMerchandiseLogisticUnitHome.vue?vue&type=script&lang=js"

import "./FrmDumpMerchandiseLogisticUnitHome.vue?vue&type=style&index=0&id=4c18579d&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__